import React from 'react';
import {getSustainabilityIconName} from "@product/data/sustainability/sustainability-icon-mapping.ts";
import SideSelectionItem from "../../components/side-section/SideSelectionItem.jsx";

export default function SustainabilityCategoryDetails({categories}) {
    if (!categories || categories.length === 0) {
        return <></>;
    }

    return ( <>
        {categories.map((category, index) => (
            <SideSelectionItem  key={index}
                                iconName={getSustainabilityIconName(category.icon.featureName)}
                                header={category.name}
                                content={category.text}
            />
        ))}
    </>);
}
